import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {ToastrModule} from 'ngx-toastr';
import {AppComponent} from './app.component';
import {AdminLayoutComponent} from './layouts/admin-layout/admin-layout.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AppRoutingModule} from './app-routing.module';
import {ComponentsModule} from './components/components.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AuthModule, LogLevel, OidcConfigService} from 'angular-auth-oidc-client';
import {EditorModule} from '@progress/kendo-angular-editor';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {DemoMaterialModule} from "./shared/material-module";
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {DBConfig, NgxIndexedDBModule} from "ngx-indexed-db";
import {APP_BASE_HREF} from "@angular/common";
import {ForbiddenComponent} from "./Forbidden/Forbidden.component";


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');

}

export function configureAuth(oidcConfigService: OidcConfigService) {
  return () =>
    oidcConfigService.withConfig({
      clientId: '7e56720b-7348-483d-bda3-892f3aa6f311',
      stsServer: 'https://mac.medis.land',
      responseType: 'code',
      redirectUrl: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      scope: 'openid profile apiService_f89dbcdd-fcfb-400b-8b0c-c528718df5e5 offline_access',
      silentRenew: true,
      useRefreshToken: true,
      silentRenewUrl: `${window.location.origin}/silent-renew.html`,
      renewTimeBeforeTokenExpiresInSeconds: 10,
     // logLevel: LogLevel.Debug,
    });
}

// export function migrationFactory() {
//   // The animal table was added with version 2 but none of the existing tables or data needed
//   // to be modified so a migrator for that version is not included.
//   return {
//     1: (db, transaction) => {
//       const store = transaction.objectStore('people');
//       store.createIndex('country', 'country', {unique: false});
//     },
//     3: (db, transaction) => {
//       const store = transaction.objectStore('people');
//       store.createIndex('age', 'age', {unique: false});
//     }
//   };
// }

// const dbConfig: DBConfig = {
//   name: 'MyDb',
//   version: 3,
//   objectStoresMeta: [{
//     store: 'people',
//     storeConfig: {keyPath: 'id', autoIncrement: true},
//     storeSchema: [
//       {name: 'name', keypath: 'name', options: {unique: false}},
//       {name: 'email', keypath: 'email', options: {unique: false}}
//     ]
//   }, {
//     // animals added in version 2
//     store: 'category',
//     storeConfig: {keyPath: 'id', autoIncrement: true},
//     storeSchema: [
//       {name: 'name', keypath: 'name', options: {unique: true}},
//     ]
//   }
//   ],
//   // provide the migration factory to the DBConfig
//   migrationFactory
// };


@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    DemoMaterialModule,
    FontAwesomeModule,
    AppRoutingModule,
    AuthModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot(),
    EditorModule,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production,scope: '/', registrationStrategy: 'registerImmediately' }),
  ],
  declarations: [AppComponent, AdminLayoutComponent,ForbiddenComponent],
  providers: [
    OidcConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureAuth,
      deps: [OidcConfigService],
      multi: true,
    },{provide: APP_BASE_HREF, useValue: '/'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
